module.exports = __webpack_public_path__ + "img/Loyalty Icon - white.deae0cd4.svg";